import React, { memo, useCallback } from 'react';

import { Button, DynamicIconWrapper, Icons, SpinnerOverlay } from '@components/common';

import { useMutateSchemaExport } from '@hooks/configurationDataModelManagement/useMutateSchemaExport';
import useQuerySchemaConfigView from '@hooks/configurationDataModelManagement/useQuerySchemaConfigView';

import styles from './SchemaTree.module.scss';

interface IMavenirConfigTree {
	id: string | undefined;
	onClose: () => void;
	isOranVendor: boolean;
}

const SchemaTree = ({
	id,
	onClose,
	isOranVendor,
}: IMavenirConfigTree) => {
	const { exportSchema, isLoadingExportSchema } = useMutateSchemaExport({
		isOranVendor,
	});
	const { schemaTree, isLoadingSchemaConfigTree } = useQuerySchemaConfigView({
		id,
		isOranVendor,
	});

	const handleExportConfig = useCallback(() => {
		if (!id) return;

		exportSchema({ ids: [id] });
	}, [exportSchema, id]);

	return (
		<div className={styles.wrapper}>
			{(isLoadingSchemaConfigTree || isLoadingExportSchema) && <SpinnerOverlay />}
			<div className={styles.textContainer}>
				{schemaTree}
			</div>
			<div className={styles.buttonWrapper}>
				<DynamicIconWrapper
					icon={Icons.export}
					isDisabled={!schemaTree}
					onClick={handleExportConfig}
					tooltipLabel='Export'
				/>
				<Button
					onClick={onClose}
					text='Close'
				/>
			</div>
		</div>
	);
};

export default memo(SchemaTree);
